import React, { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { firestore } from "../shared/FirebaseConfig";
import { useUser } from "../shared/UserContext";
import ToggleSwitch from "../shared/ToggleSwitch";
import "./LunchSettings.css";

// Editable chip list for one menu (entrées or drinks). Persists the whole array
// on every change via onSave.
function ListEditor({ title, items, onSave }) {
  const [draft, setDraft] = useState("");

  const add = () => {
    const v = draft.trim();
    if (!v || items.some((i) => i.toLowerCase() === v.toLowerCase())) {
      setDraft("");
      return;
    }
    onSave([...items, v]);
    setDraft("");
  };
  const remove = (item) => onSave(items.filter((i) => i !== item));

  return (
    <div className="lunch-list">
      <div className="settings-label">{title}</div>
      <div className="lunch-chips">
        {items.map((item) => (
          <span key={item} className="lunch-chip">
            {item}
            <button type="button" onClick={() => remove(item)} aria-label={`Remove ${item}`}>×</button>
          </span>
        ))}
        {items.length === 0 && <span className="lunch-empty">No options yet</span>}
      </div>
      <div className="lunch-add">
        <input
          type="text"
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); add(); } }}
          placeholder="Add an option…"
          className="settings-input"
        />
        <button type="button" className="btn-secondary" onClick={add} disabled={!draft.trim()}>Add</button>
      </div>
    </div>
  );
}

export default function LunchSettings() {
  const { schoolId, lunchEnabled, lunchEntrees, lunchDrinks } = useUser();
  const [msg, setMsg] = useState("");

  const save = async (patch) => {
    if (!schoolId) return;
    setMsg("");
    try {
      await updateDoc(doc(firestore, "schools", schoolId), patch);
    } catch (err) {
      console.error("Error saving lunch settings:", err);
      setMsg("Couldn't save. Try again.");
    }
  };

  return (
    <div className="settings-field-block">
      <h3 style={{ marginTop: 0 }}>Lunch selection</h3>
      <p className="settings-note" style={{ marginBottom: "var(--space-3)" }}>
        When on, taking attendance prompts for each student's lunch — teachers pick an entrée and a
        drink as they check the student in. Counts roll up school-wide on the Attendance page
        (“Lunch counts”), grouped by class or grade.
      </p>

      <ToggleSwitch
        id="lunch-enabled"
        checked={lunchEnabled}
        onChange={(v) => save({ lunchEnabled: v })}
        label={lunchEnabled ? "Lunch selection is on" : "Lunch selection is off"}
      />

      {lunchEnabled && (
        <div className="lunch-editors">
          <ListEditor title="Entrées" items={lunchEntrees} onSave={(v) => save({ lunchEntrees: v })} />
          <ListEditor title="Drinks" items={lunchDrinks} onSave={(v) => save({ lunchDrinks: v })} />
        </div>
      )}

      {msg && <p className="settings-status is-error">{msg}</p>}
    </div>
  );
}
